// TODO: These should be dynamic...
const API_BASE = '/content/data'

export const SITE_ROUTES_API = `${ API_BASE }/site-routes.json`